<template>
  <div  class="custom-form-select cursor-pointer">
    <div
      :style="{ height: height, background : bgColor, border }"
      class="custom-form-select__selected closed"
      @click="showOptions = !showOptions"
    >
      <p>
        {{ selected }}
        <span v-if="!selected" :style="{ color }">{{ placeholder }}</span>
      </p>
      <span>
        <dropdown-arrow />
      </span>
    </div>
    <transition name="select-options">
      <div class="custom-form-select__options" v-if="showOptions">
        <div class="custom-form-select__option cursor-pointer">
          <slot></slot>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import DropdownArrow from "./DropdownArrowSvg";
export default {
  components: {
    DropdownArrow,
  },
  props: {
    placeholder: {
      required: false,
    },
    selected: {
      required: true,
    },
    height : {
      required: false,
      default: "2.45rem"
    },
    bgColor : {
      required: false,
      default: "#fafafd"
    },
    border : {
      require: false,
      default: "0.5px solid #c5d1e6"
    },
    color: {
      required : false,
      default: "black"
    }
  },
  data() {
    return {
      showOptions: false,
    };
  },
  watch: {
    selected() {
      this.showOptions = !this.showOptions;
    },
  },
  methods: {
    handleSelectEvent(option) {
      this.selected = option;
      this.$emit("input", option);
      this.showOptions = false;
    },
  },
};
</script>

<style scoped>
.custom-form-select {
  position: relative;
}
.custom-form-select__selected {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 4px;
  padding: 0.45rem 0.75rem;
  width: 100%;
  overflow: hidden;
  box-sizing: border-box;
  border-radius: 4px;
}
.default-border {
  border: 0.5px solid #c4c4c4;
  border-radius: 4px;
}
.border-secondary-orange {
  border: 0.5px solid #f8ad91;
  border-radius: 4px;
}
.custom-form-select__options {
  position: absolute;
  width: 100%;
  background-color: #ffffff;
  z-index: 999;
  border: 0.5px solid #f8ad91;
  padding: 0.45rem 0.35rem;
  margin-top: 1rem;
  background: #ffffff;
  border: 0.5px solid #c5d1e6;
  box-sizing: border-box;
  border-radius: 4px;
  max-height: 20rem;
  overflow-y: auto;
}
.custom-form-select__option {
  padding: 0.5rem 0.35rem;
}
.custom-form-select__option > p:hover {
  background: #fafafd;
}
.custom-form-select__option.active {
  background: #f57a4d;
  border-radius: 3px;
  color: #ffffff;
}
.select-options-enter,
.select-options-leave-to {
  opacity: 0;
  transform: translateY(-20%);
}
.select-options-enter-to,
.select-options-leave {
  opacity: 1;
  transform: translateY(0);
}
.select-options-enter-active,
.select-options-leave-active {
  transition: all ease 0.4s;
}
</style>
